export default __webpack_public_path__ + "static/media/BlogReact.5000ee52.png";